/*该JS都是跟时间相关的方法*/

//将时间梭格式转化“年/月/日 小时：分钟：秒”，若传入的为空则给当前时间
//第二个 参数1的话就是年月日，否则是年月日时分秒
function getTimes(nS, n) {
  var date = new Date();
  if (nS != null) {
    date = new Date(parseInt(nS));
  }
  var year = date.getFullYear();
  var mon = date.getMonth() + 1;
  var day = date.getDate();
  var hours = date.getHours();
  var minu = date.getMinutes();
  var sec = date.getSeconds();
  if (mon < 10) {
    mon = "0" + mon;
  }
  if (day < 10) {
    day = "0" + day;
  }
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minu < 10) {
    minu = "0" + minu;
  }
  if (sec < 10) {
    sec = "0" + sec;
  }
  if(n == 'yyyy-MM-dd HH:mm'){
      return year + '-' + mon + '-' + day + ' ' + hours + ':' + minu;
  } else if(n == 'yyyy-MM-dd'){
      return year + '-' + mon + '-' + day;
  }else if(n == 'yyyyMMdd'){
      return year + mon + day + '';
  }else if(n == 'HH:mm:ss'){
      return hours + ':' + minu + ':' + sec;
  }else if(n == 'HH:mm'){
      return hours + ':' + minu;
  }else {
    return year + '-' + mon + '-' + day + ' ' + hours + ':' + minu + ':' + sec;
  }
}

//修改el-date-picker标签直接出来的时间日期格式
function format(time, format) {
  var t = new Date(time);
  var tf = function (i) {
    return (i < 10 ? '0' : '') + i
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear());
        break;
      case 'MM':
        return tf(t.getMonth() + 1);
        break;
      case 'mm':
        return tf(t.getMinutes());
        break;
      case 'dd':
        return tf(t.getDate());
        break;
      case 'HH':
        return tf(t.getHours());
        break;
      case 'ss':
        return tf(t.getSeconds());
        break;
    }
  })
}

//将传入的日期数组中在某时间段的日期内少的日期补全(echarts图表应用)
function completionDate(begDate, endDate, date) {
  var end_time = Date.parse(endDate);
  var start_time = Date.parse(begDate);
  var date1 = new Array();
  var i = 1;
  while (end_time >= start_time) {
    var date_formatter = new Date(start_time);
    var date_time = (date_formatter.getFullYear() + "-" + (date_formatter.getMonth() + 1) + "-" + date_formatter.getDate());
    if (!date.contain(date_time)) {
      date1.push(date_time);
    }
    start_time = start_time + i * 24 * 60 * 60 * 1000;
  }
  console.log(date1);
  return date1;
}

export { //很关键
  getTimes,
  format,
  completionDate
}




// WEBPACK FOOTER //
// ./src/components/Common/datetime.js